import protoRoot from "../proto-root";
import DataBuildInformation from "../private/DataBuildInformation";
import SupportedFeatures from "../private/SupportedFeatures";
import ParentStationState from "../private/ParentStationState";

const name = "startMonitoringRPCRequest";

function create({ avatarId, parentStationState }) {
  const StartMonitoringRPCRequest = protoRoot.lookupType(
    "comm.StartMonitoringRPCRequest"
  );
  const Avatar = protoRoot.lookupType("comm.Avatar");

  const payload = {
    avatar: avatarId
      ? Avatar.create({
          objectId: avatarId
        })
      : undefined,
    versionInfo: DataBuildInformation.create(),
    supportedFeatures: SupportedFeatures.create({ stationType: "parent" }),
    parentStationState: ParentStationState.create(parentStationState)
  };

  const request = StartMonitoringRPCRequest.create(payload);
  return { payload: request, name };
}

export default {
  create,
  name
};
